<template>
    <div id="bst-wrap">
      <div class="l-project-wrap l-project-wrap--mypage">
        <Header v-if="contactUsStore.isLoggedIn"/>
        <header v-else class="l-header l-header--top">
          <PublicPageHeader />
        </header>

        <section class="l-content-area">
          <div class="l-content">

            <!-- MYPAGE -->
            <section class="p-bloc p-bloc--mypage">
              <div class="p-bloc__content l-wrap__outer">
                <div class="l-wrap__inner">

                  <section class="p-mypage">

                    <!-- Mypage Menu -->
                    <NavbarMyPage v-if="contactUsStore.isLoggedIn"/>

                    <!-- Side Menu -->
                    <SideMenu v-if="contactUsStore.isLoggedIn"/>

                    <!-- Mypage Content -->
                    <div ref="formRef" class="p-mypage__content">
                      <div class="mypage-content">

                        <!-- contact -->
                        <div class="p-mypage__contact mypage-bloc">
                          <div class="mypage-bloc__head">
                            <h2>{{ $t("LABEL_CONTACT_US") }}</h2>
                          </div>
                          <div class="mypage-bloc__content">

                            <!-- contact form - input -->
                            <div class="contact__form">
                                <ContactUsAgreement v-if="contactUsStore.step == 'agreement'"/>
                                <ContactUsForm v-if="contactUsStore.step == 'input'"/>
                                <ContactUsConfirm v-if="contactUsStore.step == 'confirm'"/>
                                <ContactUsComplete v-if="contactUsStore.step == 'complete'"/>
                            </div>

                          </div>
                        </div>

                      </div><!-- .mypage-content -->
                    </div>

                  </section>

                </div>
              </div>
            </section>


          </div><!-- .l-content -->
        </section><!-- .l-content-area -->

      </div><!-- .l-project-wrap -->

      <Footer v-if="contactUsStore.isLoggedIn"/>
      <PublicFooter v-else/>
    </div>
</template>

<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import ContactUsAgreement from "@/components/ContactUsAgreement.vue";
import ContactUsForm from "@/components/ContactUsForm.vue";
import ContactUsConfirm from "@/components/ContactUsConfirm.vue";
import ContactUsComplete from "@/components/ContactUsComplete.vue";
import { useContactUsStore } from "@/stores/contactUsStore";
import { useSessionStore } from "@/stores/sessionStore";
import { onBeforeMount, onMounted } from "vue";

const contactUsStore = useContactUsStore();
const sessionStore = useSessionStore();
onBeforeMount(async () => {
    contactUsStore.isLoggedIn = sessionStore.isLoggedIn();
    contactUsStore.resetValues();
});

onMounted(async () => {
    window.scrollTo(0,0);
});
</script>